import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectDebitComponent } from './direct-debit.component';
import { CheckForCardComponent } from './components/check-for-card/check-for-card.component';
import { DestinationCardsComponent } from './components/destination-cards/destination-cards.component';
import { CarouselDirectDebitComponent } from './components/carousel-card/carousel-card.component';
import { DirectDebitService } from './services/direct-debit.service';
import { DirectDebitGuard } from './guard/direct-debit.guard';
import { DirectDebitRoutingModule } from './direct-debit-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardAutocompleteComponent } from './components/card-autocomplete/card-autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { SuccessComponent } from './components/success/success.component';
import { SharedModule } from '../../shared/shared.module';
import { CardholdersCoreModule } from '../../shared/cardholders-core/cardholders-core.module';
import { TransferPopupComponent } from './components/destination-cards/transfer-popup/transfer-popup.component';
import { MaterialModule } from '../material/material.module';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SuccessPopupComponent } from './components/success/success-popup/success-popup.component';
import { ErrorPopupComponent } from './components/error-popup/error-popup.component';
import { ErrorComponent } from './components/error/error.component';
import { CalculatorResultComponent } from './components/calculator-result/calculator-result.component';
import { CalculatorPopupComponent } from './components/card-autocomplete/calculator-popup/calculator-popup.component';
// tslint:disable-next-line:max-line-length
import { CalculatorSectionComponent } from './components/card-autocomplete/calculator-popup/calculator-section/calculator-section.component';
import { PopupLegalComponent } from './components/popup-legal/popup-legal.component';

@NgModule({
    declarations: [
        DirectDebitComponent,
        CheckForCardComponent,
        CardAutocompleteComponent,
        DestinationCardsComponent,
        CarouselDirectDebitComponent,
        TransferPopupComponent,
        SuccessComponent,
        SuccessPopupComponent,
        ErrorPopupComponent,
        ErrorComponent,
        CalculatorResultComponent,
        CalculatorPopupComponent,
        CalculatorSectionComponent,
        PopupLegalComponent
    ],
    imports: [
        CommonModule,
        DirectDebitRoutingModule,
        MatAutocompleteModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        CardholdersCoreModule,
        SlickCarouselModule,
        MaterialModule
    ],
    providers: [DirectDebitService, DirectDebitGuard]
})
export class DirectDebitModule {}
